var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_vote_page"},[(_vm.showSuccessPage)?_c('success-popup'):_vm._e(),(_vm.showLoginStatus)?_c('need-login-popup'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }